// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #efefef;
  font-family: "Open Sans", sans-serif;
  text-align: center;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.planContainer {
  display: flex;
  flex-wrap: wrap;
  margin: 1em;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.plan {
  background: white;
  width: 20em;
  box-sizing: border-box;
  text-align: center;
  margin: 1em;
  margin-bottom: 1em;
}
.plan .titleContainer {
  background: rgb(165, 177, 189);
  background: -webkit-gradient(left top, left bottom, color-stop(0%, rgb(165, 177, 189)), color-stop(100%, rgb(16, 116, 224)));
  background: linear-gradient(to bottom, rgb(165, 177, 189) 0%, rgb(16, 116, 224) 100%);
  padding: 1.4em;
}
.plan .titleContainer .title {
  font-size: 1.7em;
  text-transform: uppercase;
  color: white;
  font-weight: 700;
}
.plan .titleContainer .price {
  font-size: 1.45em;
  padding-top: 1em;
  padding-bottom: 0.25em;
  color: white;
  font-weight: 500;
  margin-top: 0;
  display: inline-block;
  width: 80%;
}
.plan .titleContainer .price p {
  font-size: 1.45em;
  display: inline-block;
  margin: 0;
}
.plan .titleContainer .price span {
  font-size: 1.0875em;
  display: inline-block;
}
.plan .infoContainer {
  padding: 1em;
  color: #4e4e4e;
  box-sizing: border-box;
}
.plan .infoContainer .desc {
  padding: 1em 0;
  border-bottom: 2px solid #efefef;
  margin: 0 auto;
  width: 90%;
}
.plan .infoContainer .desc em {
  font-size: 1em;
  font-weight: 500;
}
.plan .infoContainer .features {
  font-size: 1em;
  list-style: none;
  padding-left: 0;
}
.plan .infoContainer .features li {
  padding: 0;
}
.plan .infoContainer .selectPlan {
  border: 2px solid #4e4e4e;
  padding: 0.75em 1em;
  border-radius: 2.5em;
  cursor: pointer;
  transition: all 0.25s;
  margin: 1em auto;
  box-sizing: border-box;
  max-width: 70%;
  display: block;
  font-weight: 700;
}
.plan .infoContainer .selectPlan:hover {
  background: rgb(165, 177, 189);
  background: -webkit-gradient(left top, left bottom, color-stop(0%, rgb(165, 177, 189)), color-stop(100%, rgb(16, 116, 224)));
  background: linear-gradient(to bottom, rgb(165, 177, 189) 0%, rgb(16, 116, 224) 100%);
  color: white;
}

@media screen and (max-width: 25em) {
  .planContainer {
    margin: 0;
  }
  .planContainer .plan {
    width: 100%;
    margin: 1em 0;
  }
}
.promo {
  font-size: 16px;
  color: white;
  font-weight: bold;
}

.toggle-precios {
  color: white;
  font-weight: bold;
}

.imagen-stripe {
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/app/componentes/actualizar-plan/actualizar-plan.component.scss"],"names":[],"mappings":"AAeA;EACE,yBANW;EAOX,oCAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,WApBY;EAqBZ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAhCY;EAiCZ,kBAjCY;AAoBd;AAcE;EACE,8BAAA;EAMA,4HAAA;EAqBA,qFAAA;EAKA,cAAA;AArCJ;AAsCI;EACE,gBAnEO;EAoEP,yBAAA;EACA,YAAA;EACA,gBAAA;AApCN;AAsCI;EACE,iBAxEO;EAyEP,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;AApCN;AAqCM;EACE,iBAjFK;EAkFL,qBAAA;EACA,SAAA;AAnCR;AAqCM;EACE,mBAAA;EACA,qBAAA;AAnCR;AAuCE;EACE,YAhGW;EAiGX,cAlGS;EAmGT,sBAAA;AArCJ;AAsCI;EACE,cAAA;EACA,gCAAA;EACA,cAAA;EACA,UAAA;AApCN;AAqCM;EACE,cApGO;EAqGP,gBAAA;AAnCR;AAsCI;EACE,cAzGS;EA0GT,gBAAA;EACA,eAAA;AApCN;AAqCM;EACE,UAAA;AAnCR;AAsCI;EACE,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AApCN;AAqCM;EACE,8BAAA;EAMA,4HAAA;EAqBA,qFAAA;EAKA,YAAA;AA5DR;;AAkEA;EACE;IACE,SAAA;EA/DF;EAgEE;IACE,WAAA;IACA,aAAA;EA9DJ;AACF;AAkEA;EACC,eAAA;EACA,YAAA;EACA,iBAAA;AAhED;;AAkEA;EACC,YAAA;EACA,iBAAA;AA/DD;;AAiEC;EACO,YAAA;AA9DR","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800\");\n\n$accent-color: -o-linear-gradient(\n  top,\n  rgba(165, 177, 189, 1) 0%,\n  rgba(16, 116, 224, 1) 100%\n);\n$text-color: #4e4e4e;\n$plan-padding: 1em;\n$plan-margin: 1em;\n$background: #efefef;\n$title-size: 1.7em;\n$price-size: 1.45em;\n$feature-size: 1em;\n\nbody {\n  background-color: $background;\n  font-family: \"Open Sans\", sans-serif;\n  text-align: center;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n.planContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin: $plan-margin;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.plan {\n  background: white;\n  width: 20em;\n  box-sizing: border-box;\n  text-align: center;\n  margin: $plan-margin;\n  margin-bottom: $plan-margin;\n  .titleContainer {\n    background: rgba(165, 177, 189, 1);\n    background: -moz-linear-gradient(\n      top,\n      rgba(165, 177, 189, 1) 0%,\n      rgba(16, 116, 224, 1) 100%\n    );\n    background: -webkit-gradient(\n      left top,\n      left bottom,\n      color-stop(0%, rgba(165, 177, 189, 1)),\n      color-stop(100%, rgba(16, 116, 224, 1))\n    );\n    background: -webkit-linear-gradient(\n      top,\n      rgba(165, 177, 189, 1) 0%,\n      rgba(16, 116, 224, 1) 100%\n    );\n    background: -o-linear-gradient(\n      top,\n      rgba(165, 177, 189, 1) 0%,\n      rgba(16, 116, 224, 1) 100%\n    );\n    background: -ms-linear-gradient(\n      top,\n      rgba(165, 177, 189, 1) 0%,\n      rgba(16, 116, 224, 1) 100%\n    );\n    background: linear-gradient(\n      to bottom,\n      rgba(165, 177, 189, 1) 0%,\n      rgba(16, 116, 224, 1) 100%\n    );\n    padding: $plan-padding * 1.4;\n    .title {\n      font-size: $title-size;\n      text-transform: uppercase;\n      color: white;\n      font-weight: 700;\n    }\n    .price {\n      font-size: $price-size;\n      padding-top: $plan-padding * 1;\n      padding-bottom: $plan-padding * 0.25;\n      color: white;\n      font-weight: 500;\n      margin-top: 0;\n      display: inline-block;\n      width: 80%;\n      p {\n        font-size: $price-size;\n        display: inline-block;\n        margin: 0;\n      }\n      span {\n        font-size: $price-size * 0.75;\n        display: inline-block;\n      }\n    }\n  }\n  .infoContainer {\n    padding: $plan-padding;\n    color: $text-color;\n    box-sizing: border-box;\n    .desc {\n      padding: $plan-padding 0;\n      border-bottom: 2px solid $background;\n      margin: 0 auto;\n      width: 90%;\n      em {\n        font-size: $feature-size;\n        font-weight: 500;\n      }\n    }\n    .features {\n      font-size: $feature-size;\n      list-style: none;\n      padding-left: 0;\n      li {\n        padding: 0;\n      }\n    }\n    .selectPlan {\n      border: 2px solid #4e4e4e;\n      padding: $plan-padding * 0.75 $plan-padding;\n      border-radius: $plan-padding * 2.5;\n      cursor: pointer;\n      transition: all 0.25s;\n      margin: $plan-margin auto;\n      box-sizing: border-box;\n      max-width: 70%;\n      display: block;\n      font-weight: 700;\n      &:hover {\n        background: rgba(165, 177, 189, 1);\n        background: -moz-linear-gradient(\n          top,\n          rgba(165, 177, 189, 1) 0%,\n          rgba(16, 116, 224, 1) 100%\n        );\n        background: -webkit-gradient(\n          left top,\n          left bottom,\n          color-stop(0%, rgba(165, 177, 189, 1)),\n          color-stop(100%, rgba(16, 116, 224, 1))\n        );\n        background: -webkit-linear-gradient(\n          top,\n          rgba(165, 177, 189, 1) 0%,\n          rgba(16, 116, 224, 1) 100%\n        );\n        background: -o-linear-gradient(\n          top,\n          rgba(165, 177, 189, 1) 0%,\n          rgba(16, 116, 224, 1) 100%\n        );\n        background: -ms-linear-gradient(\n          top,\n          rgba(165, 177, 189, 1) 0%,\n          rgba(16, 116, 224, 1) 100%\n        );\n        background: linear-gradient(\n          to bottom,\n          rgba(165, 177, 189, 1) 0%,\n          rgba(16, 116, 224, 1) 100%\n        );\n        color: white;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 25em) {\n  .planContainer {\n    margin: 0;\n    .plan {\n      width: 100%;\n      margin: $plan-margin 0;\n    }\n  }\n}\n\n.promo{\n\tfont-size:16px;\n\tcolor:white;\n\tfont-weight: bold;\n}\n.toggle-precios{\n\tcolor: white;\n\tfont-weight: bold;\n}\n .imagen-stripe {\n        width: 300px;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
